@if (commonService.commonMainObj.invalidUser) {
  <section class="mt-5">
    <div class="vh_center mt-4">
      <div col="12">
        <div style=" margin:0px; " class="vh_center">
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_er.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #dadada;"></div>
          <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #dadada;"></div>
          <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        </div>
      </div>
    </div>
    <div class="vh_center mt-2">
      <div col="12">
        <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
          <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
          <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
          <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
        </div>
      </div>
    </div>
    <div class="text-center text-danger fw-b mt-5 fs-2">Sorry, this order cannot be placed.</div>
    <div class="text-center mt-4">
      Quote <b>{{commonService.commonMainObj.wqId}} </b> was generated with <b> {{commonService.commonMainObj.email}} </b> but you have signed in with <b> {{commonService.commonMainObj.loginEmail}} </b>
    </div>
    <div class="text-center mt-4">
      <p>
        Please restart the flow by clicking on ‘OK’ button and make sure to sign-in with the email id that was used to generate the quote.
      </p>
    </div>
    <div class="text-center mt-4">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Ok</b>
    </button>
  </div>
</section>
}
@if (!commonService.commonMainObj.invalidUser) {
  <section class="container border-0">
    <div class="vh_center mt-4">
      <div col="12">
        <div style=" margin:0px; " class="vh_center">
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #dadada;"></div>
          <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #dadada;"></div>
          <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        </div>
      </div>
    </div>
    <div class="vh_center mt-2">
      <div col="12">
        <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
          <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
          <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
          <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
        </div>
      </div>
    </div>
    <div class="row mt-5 mb-5 justify-content-center">
      <div class="col-12 d-grid gap-2">
        <button type="button" class="btn btn-warning fw6 cursor-default" style="cursor: inherit;">Order Details [{{commonService.commonMainObj.wqId}}]</button>
        <!-- <div class="p-1 bg_gray">
        <p class="m-1 text-white text-center">Order Details [WQ114215-1A]</p>
      </div> -->
    </div>
  </div>
  <div class="row">
    <div class="col-6" >
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col"><strong>Address Information</strong></div>
            <div class="col text-right">
              <button type="button" class="btn btn-custom btn-warning px-xxl-5"  (click)="addorEditAddress(addAddressModal,'','AddNewAddress')">Add New Address</button>
            </div>
          </div>
        </div>
        @if (!apiService.apiMainObj?.selectedShippingAddress?.country && !apiService.apiMainObj?.selectedBillingAddress?.country && !apiService.apiMainObj?.selectedDesignerAddress?.country) {
          <div >
            <div class="mt-3 mb-2 no-addr-error">Please fill Shipping address, Billing address and Designer address to proceed further</div>
          </div>
        }
        <div class="card m-2 p-3">
          <div class="row">
            <div class="col-4 p-0 v-center"><Strong>Shipping Address</Strong></div>
            @if (apiService.apiMainObj.selectedShippingAddress?.country != null) {
              <div class="col-5 p-0 card">
                <div class="card-body p-1">
                  @if (apiService.apiMainObj.selectedShippingAddress.country != null) {
                    <strong class="">{{apiService.apiMainObj.selectedShippingAddress.firstName}} {{apiService.apiMainObj.selectedShippingAddress.lastName}}</strong>
                    }<br>
                    <span>{{apiService.apiMainObj.selectedShippingAddress.addressLine1}},</span><br>
                    @if (apiService.apiMainObj.selectedShippingAddress?.addressLine2) {
                      <span> {{apiService.apiMainObj.selectedShippingAddress.addressLine2}}, </span>
                    }
                    <span> {{apiService.apiMainObj.selectedShippingAddress.city}}, {{apiService.apiMainObj.selectedShippingAddress.state}} {{apiService.apiMainObj.selectedShippingAddress.zip}},{{apiService.apiMainObj.selectedShippingAddress.country}}  </span><br/>
                    <span class="fs16">Phone: {{apiService.apiMainObj.selectedShippingAddress.phoneNumber}}</span>
                  </div>
                </div>
              }
              <div class="col-3 v-center">
                <button type="button" class="btn btn-custom btn-warning px-xxl-5" [disabled]="isChangeBtnDisable" (click)="openAddressBook(address_book, 'shipping')">Change</button>
              </div>
            </div>
          </div>
          <!-- <div class="m-2 mb-0"><Strong>Billing Address</Strong></div> -->
          <div class="card m-2 mt-0 p-3">
            <div class="row">
              <div class="col-4 p-0 v-center"><Strong>Billing Address</Strong></div>
              @if (apiService.apiMainObj.selectedBillingAddress?.country != null) {
                <div class="col-5 p-0 card">
                  <div class="card-body p-1">
                    <strong>{{apiService.apiMainObj.selectedBillingAddress.firstName}} {{apiService.apiMainObj.selectedBillingAddress.lastName}}</strong><br>
                    @if (apiService.apiMainObj.selectedBillingAddress.country != null) {
                      <span>
                        <span>{{apiService.apiMainObj.selectedBillingAddress.addressLine1}},</span>
                        @if (apiService.apiMainObj.selectedBillingAddress?.addressLine2) {
                          <span>{{apiService.apiMainObj.selectedBillingAddress.addressLine2}}, </span>
                        }
                        <span> {{apiService.apiMainObj.selectedBillingAddress.city}}, {{apiService.apiMainObj.selectedBillingAddress.state}} {{apiService.apiMainObj.selectedBillingAddress.zip}}, {{apiService.apiMainObj.selectedBillingAddress.country}}<br/> </span></span>
                      }
                      <span class="fs16">Phone: {{apiService.apiMainObj.selectedBillingAddress.phoneNumber}}</span>
                    </div>
                  </div>
                }
                <div class="col-3 v-center">
                  <button type="button" class="btn btn-custom btn-warning px-xxl-5" [disabled]="isChangeBtnDisable" (click)="openAddressBook(address_book, 'billing')">Change</button>
                </div>
              </div>
            </div>
            <!-- <div class="m-2 mb-0"><Strong>Designer Address</Strong></div> -->
            <div class="card m-2 mt-0 p-3">
              <div class="row">
                <div class="col-4 p-0 v-center"><Strong>Designer Address</Strong></div>
                @if (apiService.apiMainObj.selectedDesignerAddress?.country != null) {
                  <div class="col-5 p-0 card">
                    <div class="card-body p-1">
                      <strong class="fw600 fs17">{{apiService.apiMainObj.selectedDesignerAddress.firstName}} {{apiService.apiMainObj.selectedDesignerAddress.lastName}}</strong><br/>
                      @if (apiService.apiMainObj.selectedDesignerAddress.country != null) {
                        <span>
                          <span>{{apiService.apiMainObj.selectedDesignerAddress.addressLine1}},</span>
                          @if (apiService.apiMainObj.selectedDesignerAddress?.addressLine2) {
                            <span>{{apiService.apiMainObj.selectedDesignerAddress.addressLine2}}, </span>
                          }
                          <span> {{apiService.apiMainObj.selectedDesignerAddress.city}}, {{apiService.apiMainObj.selectedDesignerAddress.state}} {{apiService.apiMainObj.selectedDesignerAddress.zip}}, {{apiService.apiMainObj.selectedDesignerAddress.country}}<br/> </span></span>
                        }
                        <span class="fs16">Phone: {{apiService.apiMainObj.selectedDesignerAddress.phoneNumber}}</span>
                      </div>
                    </div>
                  }
                  <div class="col-3 v-center">
                    <button type="button" class="btn btn-custom btn-warning px-xxl-5" [disabled]="isChangeBtnDisable" (click)="openAddressBook(address_book,'designer')">Change</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-5 mb-5">
              <div class="card-header">
                <b>Shipping Info</b>
              </div>
              <div class="card-body">
                <div>
                  <label for="shipping_account">Shipping Account</label>
                  <input #shippingAccountNum class="form-control" [(ngModel)]="commonService.commonMainObj.shippingAccountNumber"  (change)="accountNumberEdit($any($event.target).value)" type="text" id="ship_account" (keyup)="commonService.removeRedBorder('ship_account')" (blur)="commonService.keyDownEvt('ship_account',apiService.apiMainObj.selectedShippingAddress.country)">
                  @if (commonService.commonMainObj.shippingAccountNumber) {
                    <div style="font-size: 14px;color: #0DB455;"  class="mt-1 mb-2">
                      Your shipping charges are being set to $0.00, since your shipping account will be used. However, if account number is found to be invalid, appropriate shipping charges will apply.
                    </div>
                  }
                </div>
                @if (commonService.commonMainObj?.shippingOptionResponse.length>0) {
                  <div>
                    <label for="shipMethod">Shipping Method</label>
                    <select id="shipMethod" [(ngModel)]="commonService.commonMainObj.shippingMethod" (change)="slectedShipping($any($event.target).value)" class="form-control form-select" placeholder="Please select shipping option">
                      @for (shipping of commonService.commonMainObj.shippingOptionResponse; track shipping; let i = $index) {
                        <option value="{{shipping.shippingID}}"><div [innerHTML]="shipping.shippingOption"></div> &nbsp;@if (apiService.apiMainObj.selectedShippingAddress.country == 'United States') {
                        <span>{{'($' + shipping.shippingPrice + ')'}}</span>
                      }</option>
                    }
                  </select>
                </div>
              }
              <div>
                <label for="shipping_notes">Shipping  & Handling Notes</label>
                <div>
                  <textarea class="form-control"  [(ngModel)]="commonService.commonMainObj.shippingNotes" rows="2"></textarea>
                </div>
              </div>
              <div class="">
                <div class="mt-2 mb-2" style="color: red;"><b>Shipping Disclaimer:</b></div>
                <ul>
                  <!-- <li>If weight of boards exceeds 1 lb, additional weight may change depending on the carrier.</li>
                  <li>Sometimes international freight may vary widely depending on country, so we reserve right to charge according to what is charged by standard carriers (UPS and FEDEX).</li>
                  <li>For same day turns, we may have to ship the boards via airplane; in such cases customer will be charged for the freight, typically around $300.</li>
                  <li>Please check <a href="https://www.fedex.com" target="_blank" >FEDEX</a> website or <a href="https://www.ups.com" target="_blank">UPS</a> website for exact service details.</li>
                  <li>These are the only shipping options available for shipping outside USA. For <strong>international shipments</strong>, rates depend on country and location. The appropriate shipping/courier charges will be applied to your credit card.</li> -->
                  <li>Sierra Circuit's charges based on the estimated weight. If the actual shipping charge is more than the estimated shipping charge, Sierra reserves the right to charge the difference.</li>
                  <li>The customer must provide the shipping account number for international shipments and be responsible for any expenses, customs duties, etc. Inaccurate information may result in a delay or shipment hold.</li>
                  <li>A custom shipping account number is required for same-day delivery.</li>
                  <li>Please check <a href="https://www.fedex.com" target="_blank" >FEDEX</a>, <a href="https://www.ups.com" target="_blank">UPS</a>, or other carrier websites for exact service details.</li>
                </ul>
              </div>
            </div>
          </div>
          
          </div>
        <div class="col-6">
          <div class="card">
            <div class="card-header">
              <strong>Quote Summary</strong>
            </div>
            <div class="m-3 text-center"><Strong>Design File Name: {{commonService.commonMainObj.uploadedFilesData?.filename}}</Strong></div>
            <!-- <div class="row">
            <div class="col-4">
              <img src="assets/img/pcblive.png" alt="board-image" width="140" class="m-2" >
            </div>
            <div class="col-8 p-0">
            </div>
          </div> -->
          <div class="m-2">
            <div class="row">
              <div class="col-8"> Number of PCB(s) </div>
              <div class="col-4 text-right"> <b>{{commonService.commonMainObj.orderSummery?commonService.commonMainObj.OrdSumNumOfPcbs:'-'}}</b> </div>
            </div>
            <div class="row">
              <div class="col-8"> PCB Turntime </div>
              <div class="col-4 text-right"> <b>{{commonService.commonMainObj.orderSummery?commonService.commonMainObj.OrdSumPcbTurnTime == 1?commonService.commonMainObj.OrdSumPcbTurnTime+' day':commonService.commonMainObj.OrdSumPcbTurnTime+" days":'-'}}</b> </div>
            </div>
            <div class="row">
              <div class="col-8"> Number of Assemblies </div>
              <div class="col-4 text-right"> <b> {{commonService.commonMainObj.orderSummery && commonService.commonMainObj.onlyPcb == false ? commonService.commonMainObj.OrdSumNumOfAssembly : '-'}} </b> </div>
            </div>
            <div class="row">
              <div class="col-8"> Assembly Turntime </div>
              <div class="col-4 text-right"> <b> {{commonService.commonMainObj.orderSummery && commonService.commonMainObj.onlyPcb == false ? commonService.commonMainObj.OrdSumAssemblyTurnTime ==1?commonService.commonMainObj.OrdSumAssemblyTurnTime+' day':commonService.commonMainObj.OrdSumAssemblyTurnTime+" days" : '-'}} </b> </div>
            </div>
          </div>
          <hr>
            <div class="m-2">
              <div class="row">
                <div class="col-7"> PCB Fabrication Charges @if (commonService.commonMainObj.ordSumEtestCharge > 0 ) {
                  <div style="font-size: x-small;padding-left: 25px;margin-top: -5px;font-style: italic;"> (Including Electrical Testing)</div>
                }</div>
                <div class="col-5 text-right"> <b>${{commonService.commonMainObj.orderSummery?to_Float(commonService.commonMainObj.OrdSumPcbCharges).toFixed(2):'-'}}</b> </div>
              </div>
              <div class="row">
                <div class="col-7"> Assembly Charges</div>
                <div class="col-5 text-right"> <b>${{commonService.commonMainObj.orderSummery && commonService.commonMainObj.onlyPcb == false ? to_Float(commonService.commonMainObj.OrdSumAssemblyCharges).toFixed(2) : '0.00'}}</b> </div>
              </div>
              <div class="row">
                <div class="col-7"> Components Charges</div>
                <div class="col-5 text-right"> <b>${{commonService.commonMainObj.orderSummery && commonService.commonMainObj.onlyPcb == false ? to_Float(commonService.commonMainObj.OrdSumComponentCharges).toFixed(2) : '0.00'}}</b> </div>
              </div>
              <!-- <div class="row">
              <div class="col-7"> Electrical testing</div>
              <div class="col-5 text-right"> <b>${{this.commonService.commonMainObj.orderSummery && this.commonService.commonMainObj.electricalTesting == "Yes" ? this.commonService.commonMainObj.ordSumEtestCharge:'0.00'}}</b> </div>
            </div> -->
            @if (apiService.apiMainObj.selectedShippingAddress.country == 'United States') {
              <div class="row">
                <div class="col-7"> Shipping Charges</div>
                <div class="col-5 text-right"> <b>${{to_Float(this.commonService.commonMainObj.shippingCost).toFixed(2)}}</b> </div>
              </div>
            }
            @if (summaryPromoShow == true) {
              <div class="row">
                <div class="col-7"> Promo Code <span class="small-bold-text">({{commonService.commonMainObj.promoCode }} applied)</span></div>
                <div class="col-5 text-right"> <b>-${{to_Float(this.commonService.commonMainObj.totalPromoDiscountAmount).toFixed(2)}}</b> </div>
              </div>
            }
            <div class="row mt-3">
              <div class="col-7"> <b>Total Cost</b></div>
              <!-- OFP-1931 removed from brlow logic -->
              <!-- + (commonService.commonMainObj.electricalTesting =='Yes' ? to_Float(commonService.commonMainObj.ordSumEtestCharge): 0.0) -->
               <div class="col-5 text-right"> <span style="color: red;font-size: small;">(Excluding Taxes) </span> <b> ${{this.commonService.commonMainObj.orderSummery?((to_Float(this.commonService.commonMainObj.OrdSumPcbCharges)+(commonService.commonMainObj.orderSummery && commonService.commonMainObj.onlyPcb == false ? to_Float(commonService.commonMainObj.assemblyComponentTotal) : 0.0) + to_Float(apiService.apiMainObj.selectedShippingAddress.country == 'United States'? commonService.commonMainObj.shippingCost:'0.00')) - (commonService.commonMainObj.totalPromoDiscountAmount != ''? to_Float(commonService.commonMainObj.totalPromoDiscountAmount) : 0.0 )).toFixed(2):"-"}}</b> </div>
            </div>
          </div>
        </div>
        @if(shippingPromoAndShppingAccoutBothPresent){
          <div class="p-1">
            <b>NOTE:</b> <span style="color: red;">Shipping charges are set to $0.00 as a shipping account number has been provided. Promo code shipping discounts are not applied.</span>
          </div>
        }
        <div id="promo_cod_sec" class="card mt-5 p-3 pt-0">
          <div class="row align-items-center">
            <div class="col-4">
              <strong>Promo Code</strong>
            </div>
            <div class="col-5 text-center">
              <input id="promo_code" class="form-control promo-input mt-4" type="text" [(ngModel)]="promoCodeText" name="promo-code" (keyup)="promoKeyUp($event)" placeholder="Promo code">
              <button class="reset-promo" (click)="promoReset();">×</button>
            </div>
            <div class="col-3">
              <button type="button" class="btn btn-custom btn-warning px-xxl-5" id="promo_code_apply" (click)="promoCodeApply();">Apply</button>
            </div>
          </div>
          @if (summaryPromoShow == true) {
            <div class="small-bold-text">
              @if (commonService.commonMainObj.pcbPromoDiscount) {
                <span>PCB: ${{commonService.commonMainObj.pcbPromoDiscount}}</span>
              }
              @if (commonService.commonMainObj.assemblyPromoDiscount) {
                <span>, ASSEMBLY: ${{commonService.commonMainObj.assemblyPromoDiscount}}</span>
              }
              @if (commonService.commonMainObj.componentPromoDiscount) {
                <span>, COMPONENTS: ${{commonService.commonMainObj.componentPromoDiscount}},</span>
              }
              @if (commonService.commonMainObj.shippingPromoDiscount) {
                <span> SHIPPING: ${{commonService.commonMainObj.shippingPromoDiscount}}</span>
              }
            </div>
          }
        </div>
        <div class="card mb-5 " style="margin-top: 4.5rem !important;">
              <div class="card-header"> Tax & Resale Info </div>
              @if (taxShowing?.visible) {
                <div class="card-body p-3">
                  <div class="row align-items-center">
                    @for (name of tax_options; track name; let i = $index) {
                      <div class="col-md-4" >
                        <input type="radio" name="" id="TaxOption{{i}}" class="" value="{{ name['name'] }}" (click)="tax_radio_changed(name['name'])">
                        <label class="tax-lable">{{ name['name'] }}</label>
                      </div>
                    }
                  </div>
                  @if (sel_tax_option ==='Non-taxable') {
                    <div class="non-tax-info card mt-3" >
                      <div  class="card-body">
                        <strong>Choose at least one of the following reasons why your order is non-taxable:</strong>
                        <div class="mt-3">
                          <label>I have a resale number</label>
                          <input #resaleSection [(ngModel)]="commonService.commonMainObj.resaleNumber" type="text" id="resale_num" placeholder="" name="resale-number" class="form-control">
                        </div>
                        <div class="mt-2">
                          <label>I have a tax exempt certificate number</label>
                          <input type="text" [(ngModel)]="commonService.commonMainObj.taxExemptCertiNumber" id="tax_exempt" placeholder="" name="resale-number" class="form-control">
                        </div>
                        <div class="mt-2">
                          <label>My order is being shipped to california temporarily (for assembly/inspection/etc.) and then it will be sent outside california to this final destination</label>
                          <input type="text" [(ngModel)]="commonService.commonMainObj.taxExemptOutsideCalifornia" id="calif_temp" placeholder="" name="resale-number" class="form-control">
                        </div>
                        <div class="mt-3 danger">
                          <strong>
                            Note about resale numbers<br>
                          </strong>
                          (applicable to orders shipping to california only)
                        </div>
                        <div class="mt-3 danger">
                          <ol style="margin: 0px;">
                            <li>If these boards are for resale, you must enter a valid resale number and email a copy of your resale card to <a href="mailto:FAX@protoexpress.com">fax&#64;protoexpress.com</a> (make subject line: resale card) or fax it to <span class="fw600">408-735-1408</span>. Download a template for resale card <a href="{{apiService.resaleCertiUrl}}" target="_blank">here</a>.</li>
                            <li>If you have provided a resale number in an earlier order you may find it pre-filled in the field above (and in such cases, if you have already sent us your resale card you do not need to send it again).</li>
                            <li>If the resale number you provide is not valid and/or we do not have your resale card on file before order ship date, your order will be charged california sales tax.</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (!taxShowing?.visible && taxShowing.message) {
                <div style="padding: 0px;">
                  Shipments outside {{taxShowing.message}} are not taxed
                </div>
              }
            </div>
        <!-- OFP-3889 freedom paypal -->
        <!-- <div class="card  mt-5" [ngClass]="commonService.commonMainObj.isNotAuthChecked ? 'disable-div' : '' ">
          <div class="card-header"><strong>Payment Method Information</strong></div>
          <form [formGroup]="paymentForm">
            <div class="card-body p-3">
              <div class="">
                <label for="card_name">Name on Card</label>
                <input [(ngModel)]="commonService.commonMainObj.cardHolderName"  type="text" class="form-control" id="name_on_card" #cardName formControlName="nameOnCard" autocomplete="cc-name" required (keyup)="commonService.removeRedBorder('name_on_card')">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of payment_validation_messages.nameOnCard; track validation) {
                  @if (paymentForm.get('nameOnCard')?.hasError(validation.type) && (paymentForm.get('nameOnCard')?.dirty || paymentForm.get('nameOnCard')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div class="mt-2 mb-2">
                <label for="card_number">Card Number</label>
                <div class="input-group">
                  <input #cardNum [(ngModel)]="commonService.commonMainObj.cardNumber" (keyup)="cardNumber($event)" (keyup)="commonService.removeRedBorder('card_number')" type="text" id="card_number"  class="form-control" name="ccno" formControlName="cardNumber" autocomplete="cc-number">
                  <div class="input-group-append">
                    <span class="input-group-text card-input" id="">
                      <img id="card_type" src="" alt="" width="45px">
                    </span>
                  </div>
                </div>
              </div>
              <div class="validation-errors mb-2">
                @for (validation of payment_validation_messages.cardNumber; track validation) {
                  @if (paymentForm.get('cardNumber')?.hasError(validation.type) && (paymentForm.get('cardNumber')?.dirty || paymentForm.get('cardNumber')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div class="row g-3">
                <div class="col-md">
                  <div class="form-floating">
                    <select class="form-control form-select" [(ngModel)]="commonService.commonMainObj.selectedCardExpiryMonth"  (change)="monthChanged($any($event.target).value)" name="ccexpmon"  formControlName="expMonth" id="exp_month" autocomplete="cc-exp-month">
                      @for (months of expiryMonths; track months) {
                        <option value="{{months.value}}">{{months.value}}</option>
                      }
                    </select>
                    <label for="floatingSelectGrid">Expiry Month</label>
                  </div>
                  <div class="validation-errors mb-2">
                    @for (validation of payment_validation_messages.expMonth; track validation) {
                      @if (paymentForm.get('expMonth')?.hasError(validation.type) && (paymentForm.get('expMonth')?.dirty || paymentForm.get('expMonth')?.touched)) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-floating">
                    <select class="form-control form-select" [(ngModel)]="commonService.commonMainObj.selectedCardExpiryYear" (change)="yearChanged($any($event.target).value)" name="ccexpyear"  interface="popover" formControlName="expYear" id="exp_year" autocomplete="cc-exp-year">
                      @for (year of expiryYear; track year) {
                        <option  value="{{year.name}}">{{year.name}}</option>
                      }
                    </select>
                    <label for="floatingSelectGrid">Expiry Year</label>
                  </div>
                  <div class="validation-errors mb-2">
                    @for (validation of payment_validation_messages.expYear; track validation) {
                      @if (paymentForm.get('expYear')?.hasError(validation.type) && (paymentForm.get('expYear')?.dirty || paymentForm.get('expYear')?.touched)) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-floating">
                    <input [(ngModel)]="commonService.commonMainObj.cardCvvNumber" #cardCvv type="password" id="cvv" class="form-control" name="CARD CVV" formControlName="cvv" autocomplete="cc-csc" (keyup)="commonService.removeRedBorder('cvv')">
                    <label for="floatingInputGrid">CVV</label>
                  </div>
                  <div class="validation-errors mb-2">
                    @for (validation of payment_validation_messages.cvv; track validation) {
                      @if (paymentForm.get('cvv')?.hasError(validation.type) && (paymentForm.get('cvv')?.dirty || paymentForm.get('cvv')?.touched)) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="mt-2">
          <strong  class="text-warning">NOT AUTHORIZED TO PURCHASE?</strong><br>
          <span>(Send link to someone else to complete the payment)</span>
        </div>
        <div class="card mt-1">
          <div class="card-body p-3">
            <div class="green-txt mb-3">
            We allow you to go ahead and place the order and let the purchasing person complete the payment later.                    </div>
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" [(ngModel)]="commonService.commonMainObj.isNotAuthChecked" (change)="notAuthSelection($event)" id="not_auth_purchases">
              <label class="form-check-label" >
                I don't have all the billing/credit card info. It will be filled by my purchasing person.
              </label>
            </div>
            @if (commonService.commonMainObj.isNotAuthChecked) {
              <div class="">
                <form [formGroup]="unAuthorizedForm">
                  <label> Send link to </label>
                  <div class="row g-2">
                    <div class="col-md">
                      <div class="">
                        <input [(ngModel)]="this.commonService.commonMainObj.purchasingPersonDetails.firstName"  type="text" class="form-control" id="not_auth_first_name" #notAuthFirstName formControlName="unAuthFirstName" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_first_name')" placeholder="First Name">
                      </div>
                      <div class="validation-errors mb-2">
                        @for (validation of not_auth_validation_messages.unAuthFirstName; track validation) {
                          @if (unAuthorizedForm.get('unAuthFirstName')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthFirstName')?.dirty || unAuthorizedForm.get('unAuthFirstName')?.touched)) {
                            <div class="error-message">
                              {{ validation.message }}
                            </div>
                          }
                        }
                      </div>
                    </div>
                    <div class="col-md">
                      <div class="">
                        <input [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.lastName"  type="text" class="form-control" id="not_auth_last_name" #notAuthLastName formControlName="unAuthLasttName" autocomplete="off" placeholder="Last Name">
                      </div>
                      <div class="validation-errors mb-2">
                        @for (validation of not_auth_validation_messages.unAuthLasttName; track validation) {
                          @if (unAuthorizedForm.get('unAuthLasttName')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthLasttName')?.dirty || unAuthorizedForm.get('unAuthLasttName')?.touched)) {
                            <div class="error-message">
                              {{ validation.message }}
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <label for="card_name">Email</label>
                    <input [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.email" type="text" class="form-control" id="not_auth_email" #notAuthEmail formControlName="unAuthEmail" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_email'); validateUnauthDomain(commonService.commonMainObj.purchasingPersonDetails.email);" placeholder="Email">
                  </div>
                  @if (!unauthEmailisValid) {
                    <div class="validation-errors mb-2">
                      @for (validation of not_auth_validation_messages.unAuthEmail; track validation) {
                        @if (unAuthorizedForm.get('unAuthEmail')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthEmail')?.dirty || unAuthorizedForm.get('unAuthEmail')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  }
                  @if (unauthEmailisValid) {
                    <p class="validation-errors mb-2 error-message">{{commonService.commonMainObj.invalidEmailErrorMsg}}</p>
                  }
                  <div class="mt-2">
                    <label for="card_name">Any remarks to your purchasing person</label>
                    <textarea [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.remarks" rows="3" class="form-control" id="not_auth_remark" #notAuthRemark formControlName="unAuthRemark" autocomplete="off"  placeholder="Remarks"></textarea>
                  </div>
                <div class="mt-2 mb-3">
                  <div class="text-success fw-b">I understand that order will stay in "Pending" status at Sierra Circuits till payment info is finalized.</div>
                  <div class="form-check mt-3">
                    <input class="form-check-input agree-check" type="checkbox" value="" id="not_auth_agree" #notAuthAgreed [(ngModel)]="commonService.commonMainObj.purchasingPersonDetails.paymentPending" formControlName="unAuthAgree" (change)="authAgreedCheck($event)">
                    <label class="form-check-label" for="not_auth_agree"> <span class="text-success fw-b">Agreed</span>
                  </label>
                </div>
              </div>
              <div class="validation-errors mb-2">
                @for (validation of not_auth_validation_messages.unAuthAgree; track validation) {
                  @if (unAuthorizedForm.get('unAuthAgree')?.hasError(validation.type) && (unAuthorizedForm.get('unAuthAgree')?.dirty || unAuthorizedForm.get('unAuthAgree')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
            </form>
          </div>
        }
        </div>
        </div> -->
<div class="text-right mt-5 mb-5" style="padding-bottom: 100px;">
  <button class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="orderDetailsContinue()"><b>Review Order</b></button>
</div>
<!-- ADDRESS BOOK MODAL -->
<ng-template #address_book let-modal class="address-book-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">{{apiService.apiMainObj.addressBookName}}</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="row row-cols-2">
      @for (ad of apiService.apiMainObj.alladdress; track ad; let i = $index) {
        <div class="col" >
          <div class="card info-card mb-3" id="ac_{{ad['addressId']}}">
            <div class="card-body">
              <div><b>{{ ad['firstName'] }} {{ ad['lastName'] }}</b></div>
              @if ( ad['addressLine1']!='' ) {
                <span>{{ ad['addressLine1'] }},</span>
                } @if ( ad['addressLine2'] !='' ) {
                <span>{{ ad['addressLine2'] }},</span>
                } @if ( ad['city'] !='' ) {
                <span>{{ ad['city'] }}, </span>
              }
              @if ( ad['state'] !='' ) {
                <span>{{ ad['state'] }},</span>
                } @if ( ad['country'] !='' ) {
                <span> {{ ad['country'] }}</span>
              }
              @if ( ad['zip'] !='' ) {
                <span> {{ ad['zip'] }}</span>
                }<br>
                @if ( ad['phoneNumber'] !='' ) {
                  <span>Phone: {{ ad['phoneNumber'] }}</span>
                }
                <div class="pt-3"><input type="checkbox" id="selectAdd_{{ad['addressId']}}"  [(ngModel)]="ad['isCheckedDeliver'] " (click)="viewDeliverToAddress(ad,i)"  name="default-address"> <span id="selcted_lbl_{{ad['addressId']}}" style="padding-left: 3px;">Use this address as default</span></div>
                <div class="pt-2">
                  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="addorEditAddress(addAddressModal,ad['addressId'],'EditAddress');"><b>Edit</b></button>
                  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="confirmDeleteAddress(ad,ad['addressTypeId']);" style="margin-left: 15px;" ><b>Delete</b></button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="selectAddress();"><b>Ok</b></button>
    </div>
  </ng-template>
  <!-- ADD OR EDIT ADDRESS -->
  <ng-template #addAddressModal let-modal class="add-address-modal">
    <div class="modal-header">
      <div class="row col">
        <div class="col-11">
          <h4 class="modal-title" id="modal-basic-title">{{apiService.apiMainObj.addressAction}}</h4>
        </div>
        <div class="col-1 text-right">
          <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="modal-crose">×</span>
          </button>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <section class="container">
                <form [formGroup]="createAddressForm">
                  <div class="row g-2 mt-2">
                    <div class="col-md">
                      <label for="floatingSelectGrid">Default this address for</label>
                      <!-- <select class="select form-select" id="select_address_type" [(ngModel)]="apiService.apiMainObj.address_type_id" (change)="multiSelect($event.currentTarget)" formControlName="selectAddressType" multiple>
                      <option value="3">Shipping</option>
                      <option value="2">Billing</option>
                      <option value="1">Designer</option>
                    </select> -->
                    <div class="multiselect">
                      <div class="selectBox" (click)="showCheckboxes()">
                        <select class="form-control form-select">
                          <option>@if (!apiService.apiMainObj.isShippingChecked && !apiService.apiMainObj.isBillingChecked && !apiService.apiMainObj.isDesignerChecked) {
                            <span>Select an Option</span>
                            }@if (apiService.apiMainObj.isShippingChecked) {
                            <span>Shipping </span>
                            }@if (apiService.apiMainObj.isBillingChecked) {
                            <span> Billing </span>
                            }@if (apiService.apiMainObj.isDesignerChecked) {
                            <span> Designer </span>
                          }</option>
                        </select>
                        <div class="overSelect"></div>
                      </div>
                      <div id="checkboxes">
                        <label for="Shipping">
                        <input type="checkbox" class="m-2 address-tyep-check" id="Shipping" [(ngModel)]="apiService.apiMainObj.isShippingChecked" (change)="addressTypeSelect($event, 'shipping')" formControlName="shippingType"/> Shipping </label>
                        <label for="Billing">
                        <input type="checkbox" class="m-2 address-tyep-check" id="Billing" [(ngModel)]="apiService.apiMainObj.isBillingChecked" (change)="addressTypeSelect($event, 'billing')" formControlName="billingType"/> Billing </label>
                        <label for="Designer">
                        <input type="checkbox" class="m-2 address-tyep-check" id="Designer" [(ngModel)]="apiService.apiMainObj.isDesignerChecked" (change)="addressTypeSelect($event, 'designer')" formControlName="designerType"/> Designer </label>
                      </div>
                    </div>
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.selectAddressType; track validation) {
                        @if (createAddressForm.get('selectAddressType')?.hasError(validation.type) && (createAddressForm.get('selectAddressType')?.dirty || createAddressForm.get('selectAddressType')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="col-md">
                    <label for="company_name">Company Name<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="company_name" [(ngModel)]="apiService.apiMainObj.contact_company" placeholder="Enter N/A if not applicable" formControlName="companyName" required>
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.companyName; track validation) {
                        @if (createAddressForm.get('companyName')?.hasError(validation.type) && (createAddressForm.get('companyName')?.dirty || createAddressForm.get('companyName')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row g-2 mt-2">
                  <div class="col-md">
                    <label for="first_name">First Name<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="first_name" [(ngModel)]="apiService.apiMainObj.contact_first_name" placeholder="" formControlName="firstName">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.firstName; track validation) {
                        @if (createAddressForm.get('firstName')?.hasError(validation.type) && (createAddressForm.get('firstName')?.dirty || createAddressForm.get('firstName')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="col-md">
                    <label for="last_name">Last Name<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="last_name" [(ngModel)]="apiService.apiMainObj.contact_last_name" placeholder="" formControlName="lastName">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.lastName; track validation) {
                        @if (createAddressForm.get('lastName')?.hasError(validation.type) && (createAddressForm.get('lastName')?.dirty || createAddressForm.get('lastName')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md">
                    <label for="address_email">Email<sup class="ad-required-mark">*</sup></label>
                    <input type="email" class="form-control" id="address_email" [(ngModel)]="apiService.apiMainObj.contact_email" (keyup)="validateAddressDomain();" placeholder="" formControlName="addressEmail">
                    @if (!addressEmailisValid) {
                      <div class="validation-errors mb-2">
                        @for (validation of address_validation_messages.addressEmail; track validation) {
                          @if (createAddressForm.get('addressEmail')?.hasError(validation.type) && (createAddressForm.get('addressEmail')?.dirty || createAddressForm.get('addressEmail')?.touched)) {
                            <div class="error-message">
                              {{ validation.message }}
                            </div>
                          }
                        }
                      </div>
                    }
                    @if (addressEmailisValid && addressDomain) {
                      <p class="error-message">{{commonService.commonMainObj.invalidEmailErrorMsg}}</p>
                    }
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md">
                    <label for="address_one">Address1<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="address_one" [(ngModel)]="apiService.apiMainObj.contact_address1" placeholder="" formControlName="addressOne">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.addressOne; track validation) {
                        @if (createAddressForm.get('addressOne')?.hasError(validation.type) && (createAddressForm.get('addressOne')?.dirty || createAddressForm.get('addressOne')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md">
                    <label for="address_two">Address2</label>
                    <input type="text" class="form-control" id="address_two" [(ngModel)]="apiService.apiMainObj.contact_address2" placeholder="" formControlName="addressTwo">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.addressTwo; track validation) {
                        @if (createAddressForm.get('addressTwo')?.hasError(validation.type) && (createAddressForm.get('addressTwo')?.dirty || createAddressForm.get('addressTwo')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row g-2 mt-2">
                  <div class="col-md">
                    <label for="ad_country">Country<sup class="ad-required-mark">*</sup></label>
                    <select  id="ad_country" class="form-control form-select" [(ngModel)]="this.apiService.apiMainObj.contact_country"  (change)="countryClick($event.currentTarget)" formControlName="adCountry" tabindex="-1">
                      @for (country of apiService.apiMainObj.countryList; track country) {
                        <option  value="{{country}}">{{country}}</option>
                      }
                    </select>
                    <!-- <input type="text" class="form-control" id="ad_country" placeholder="" formControlName="adCountry" required> -->
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.adCountry; track validation) {
                        @if (createAddressForm.get('adCountry')?.hasError(validation.type) && (createAddressForm.get('adCountry')?.dirty || createAddressForm.get('adCountry')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="col-md">
                    <label for="ad_state">State<sup class="ad-required-mark">*</sup></label>
                    @if (apiService.apiMainObj.contact_country == 'United States' ) {
                      <select class="form-control form-select"  id="select_state" [(ngModel)]="apiService.apiMainObj.contact_state" (change)="stateClick($event.currentTarget)" formControlName="stateSelect" tabindex="-1" style="outline: none;">
                        @for (state of apiService.apiMainObj.stateList | keyvalue; track state) {
                          <option     [value]="state.key">{{state.key}}</option>
                        }
                      </select>
                    }
                    @if (apiService.apiMainObj.contact_country != 'United States') {
                      <input type="text" id="input_state" class="form-control" [(ngModel)]="apiService.apiMainObj.contact_state" placeholder="" formControlName="adState" required>
                    }
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.adState; track validation) {
                        @if (createAddressForm.get('adState')?.hasError(validation.type) && (createAddressForm.get('adState')?.dirty || createAddressForm.get('adState')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row g-2 mt-2">
                  <div class="col-md">
                    <label for="ad_city">City<sup class="ad-required-mark">*</sup></label>
                    @if (!showCityInputText) {
                      <select class="form-control form-select" id="select_city" [(ngModel)]="apiService.apiMainObj.contact_city" formControlName="citySelect" tabindex="-1" style="outline: none;">
                        @for (city of apiService.apiMainObj?.cityList; track city; let idx = $index) {
                          <option     value="{{city}}">{{city}}</option>
                        }
                      </select>
                    }
                    <!-- <input *ngIf="!showCityInputText" type="text"  id="input_city" [(ngModel)]="apiService.apiMainObj.contact_city" class="form-control" placeholder="" formControlName="adCity" required> -->
                    @if (showCityInputText) {
                      <input type="text"  id="input_city" [(ngModel)]="apiService.apiMainObj.contact_city" class="form-control" placeholder="" formControlName="adCity" required>
                    }
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.adCity; track validation) {
                        @if (createAddressForm.get('adCity')?.hasError(validation.type) && (createAddressForm.get('adCity')?.dirty || createAddressForm.get('adCity')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="col-md">
                    <label for="ad_zip">Zip<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="ad_zip" [(ngModel)]="apiService.apiMainObj.contact_zipcode" placeholder="" formControlName="adZip">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.adZip; track validation) {
                        @if (createAddressForm.get('adZip')?.hasError(validation.type) && (createAddressForm.get('adZip')?.dirty || createAddressForm.get('adZip')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
                <div class="row g-2 mt-2">
                  <div class="col-md">
                    <label for="ad_phone">Phone<sup class="ad-required-mark">*</sup></label>
                    <input type="text" class="form-control" id="ad_phone" [(ngModel)]="apiService.apiMainObj.contact_phone" placeholder="" formControlName="adPhone">
                    <div class="validation-errors mb-2">
                      @for (validation of address_validation_messages.adPhone; track validation) {
                        @if (createAddressForm.get('adPhone')?.hasError(validation.type) && (createAddressForm.get('adPhone')?.dirty || createAddressForm.get('adPhone')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="col-md">
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <!-- <button type="button" class="btn btn-danger btn-min-wt"(click)="cancelAddress()" style="margin-left: 15px;">Cancel</button> -->
    <!-- <button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('Save click')">Ok</button> -->
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" [disabled]="!createAddressForm.valid" (click)="addAddress()"><b>{{apiService.apiMainObj.addressBtnText}}</b></button>
  </div>
</ng-template>
</div>
</div>
</section>
}

@if (commonService.commonMainObj.invalidUser) {
  <app-footer></app-footer>
}